import React, { useState } from 'react';
import {
  TextField,
  Button,
  Box,
  InputAdornment,
} from '@mui/material';

const MobileNumberInput = ({ onSubmit }) => {
  const [mobileNumber, setMobileNumber] = useState('');
  const [error, setError] = useState('');

  const validateMobileNumber = (number) => {
    const cleanDigits = number.replace(/\D/g, '');
    if (cleanDigits.length === 10) {
      return /^[6-9]\d{9}$/.test(cleanDigits);
    }
    if (cleanDigits.length === 12 && cleanDigits.startsWith('91')) {
      return /^[6-9]\d{9}$/.test(cleanDigits.slice(2));
    }
    return false;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!mobileNumber) {
      setError('Mobile number is required');
      return;
    }
    if (!validateMobileNumber(mobileNumber)) {
      setError('Please enter a valid 10-digit mobile number');
      return;
    }
    setError('');
    onSubmit(mobileNumber);
  };

  const handleChange = (e) => {
    const value = e.target.value;
    // Allow numbers and + at the start
    if (value === '' || /^\+?[0-9]+$/.test(value)) {
      setMobileNumber(value);
      setError('');
    }
  };

  return (
    <Box component="form" onSubmit={handleSubmit} noValidate>
      <TextField
        margin="normal"
        required
        fullWidth
        id="mobileNumber"
        label="Mobile Number"
        name="mobileNumber"
        autoComplete="tel"
        autoFocus
        value={mobileNumber}
        onChange={handleChange}
        error={!!error}
        helperText={error}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              +91
            </InputAdornment>
          ),
        }}
        inputProps={{
          maxLength: 15,
          pattern: '[0-9]*',
        }}
      />
      <Button
        type="submit"
        fullWidth
        variant="contained"
        sx={{ mt: 3, mb: 2 }}
      >
        Continue
      </Button>
    </Box>
  );
};

export default MobileNumberInput; 